exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "promote-form {\n  width: 100%;\n}\npromote-form > .promote-form > .bar {\n  margin: 10px;\n  margin-top: 17.5px;\n}\n", ""]);

// exports
